"use strict";

var _moment = require("moment");

var _moment2 = _interopRequireDefault(_moment);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var MAX_DAYS = 33;

(function (angular) {
  "use strict";

  angular.module("fleetviewApp").component("complianceQueryString", {
    template: require("./compliance-querystring.component.html"),
    controller: ComplianceQueryStringController
  });

  ComplianceQueryStringController.$inject = ["$location", "$q", "LayoutService", "GroupsService", "$scope", "$state", "$stateParams"];

  function ComplianceQueryStringController($location, $q, LayoutService, GroupsService, $scope, $state, $stateParams) {
    var vm = this;
    vm.$onInit = init;
    function init() {

      var endDate = _getEndDateFromQueryString();
      var startDate = _getStartDatefromQueryString(endDate);
      var tripIds = _getTripIdsFromQueryString();
      var vehicleIds = _getVehicleIdsFromQueryString();
      var driverIds = _getDriverIdsFromQueryString();
      var hideNoOOr = _getIncludeRoutesWithNoOORMilesFromQueryString();
      var hideQuestionable = _getNoQuestionableRoutesFromQueryString();
      var promises = [_getVehicleGroupIdsFromQueryString(), _getDriverGroupIdsFromQueryString()];

      $q.all(promises).then(function (queryResults) {
        var vehicleGroupIds = queryResults[0];
        var driverGroupIds = queryResults[1];

        var ids = [];
        var groupType = "vehicle";
        var groupIds = [];

        if (vehicleGroupIds.length > 0 || vehicleIds.length > 0) {
          groupType = "vehicle";
          ids = vehicleIds;
          groupIds = vehicleGroupIds;
        } else {
          groupType = "driver";
          ids = driverIds;
          groupIds = driverGroupIds;
        }

        vm.settings = {
          startDate: startDate,
          endDate: endDate,
          idType: groupType,
          noQuestionableRoutes: hideQuestionable,
          includeRoutesWithNoOorMiles: !hideNoOOr,
          ids: ids,
          tripId: tripIds,
          groupId: groupIds
        };
        showRoutes(vm.settings);
      });
    }
    function showRoutes(settings) {
      //console.log("getting data with the following options ", vm.settings);
      $state.go($stateParams.childState, {
        settings: vm.settings,
        queryUrl: $stateParams.queryUrl
      });
      vm.startDate = vm.settings.startDate.toLocaleDateString();
      vm.endDate = vm.settings.endDate.toLocaleDateString();
    }

    function _getVehicleGroupIdsFromQueryString() {
      var groupNames = _getArrayFromQueryString("vehicleGroupName");
      if (groupNames.length === 0) {
        return $q.when([]);
      }

      var groupNamesObj = {};
      groupNames.forEach(function (groupName) {
        return groupNamesObj[groupName.toUpperCase()] = -1;
      });

      return GroupsService.getVehicleGroups().then(function (groups) {
        var groupIds = [];

        for (var i = 0; i < groups.length; i++) {
          if (groups[i].name != null && groupNamesObj[groups[i].name.toUpperCase()] === -1) {
            groupIds.push(groups[i].id);
          }
        }

        return groupIds;
      });
    }

    function _getDriverGroupIdsFromQueryString() {
      var groupNames = _getArrayFromQueryString("driverGroupName");
      if (groupNames.length === 0) return $q.when([]);

      var groupNamesObj = {};
      groupNames.forEach(function (groupName) {
        return groupNamesObj[groupName.toUpperCase()] = -1;
      });

      return GroupsService.getDriverGroups().then(function (groups) {
        var groupIds = [];

        for (var i = 0; i < groups.length; i++) {
          if (groups[i].name != null && groupNamesObj[groups[i].name.toUpperCase()] === -1) {
            groupIds.push(groups[i].id);
          }
        }

        return groupIds;
      });
    }

    function _getTripIdsFromQueryString() {
      return _getArrayFromQueryString("tripId");
    }

    function _getVehicleIdsFromQueryString() {
      return _getArrayFromQueryString("vehicleId").filter(function (c) {
        return _isNumber(c);
      }).map(function (c) {
        return parseInt(c);
      });
    }

    function _getDriverIdsFromQueryString() {
      return _getArrayFromQueryString("driverId").filter(function (c) {
        return _isNumber(c);
      }).map(function (c) {
        return parseInt(c);
      });
    }

    function _getIncludeRoutesWithNoOORMilesFromQueryString() {
      if (typeof $location.search().hideNoOOR === "string") {
        return $location.search().hideNoOOR.toUpperCase() === "TRUE";
      }

      return false;
    }

    function _getNoQuestionableRoutesFromQueryString() {
      if (typeof $location.search().hideQuestionable === "string") {
        return $location.search().hideQuestionable.toUpperCase() === "TRUE";
      }

      return true;
    }

    /**
     * Returns the initial end date for the screen.
     *
     * @returns a Date javascript object representing the end date
     */
    function _getEndDateFromQueryString() {
      var endDate = (0, _moment2.default)($location.search().endDate, _moment2.default.ISO_8601);

      // if there is no valid end date passed in, take todays date
      if (!endDate.isValid()) {
        return (0, _moment2.default)().endOf("day").toDate();
      }

      return endDate.toDate();
    }

    /**
     * Returns the initial start date for the screen.
     * If the "startDate" query string parameter exists it uses this in the calculation
     *
     * @param {any} endDateJS Date Javascript object representing the end date
     * @returns a Date Javascript object representing the start date
     */
    function _getStartDatefromQueryString(endDateJS) {
      var endDate = (0, _moment2.default)(endDateJS);

      var startDate = (0, _moment2.default)($location.search().startDate, _moment2.default.ISO_8601);

      // if date is not valid, return one month  before the end date.
      if (!startDate.isValid()) {
        return endDate.subtract(MAX_DAYS, "days").startOf("day").toDate();
      }

      // if the start date is after the end date, send the end date back
      if (startDate.isAfter(endDate)) {
        return endDate.startOf("day").toDate();
      }

      // it is a valid start date, return it back.
      return startDate.toDate();
    }

    function _getArrayFromQueryString(param) {
      var search = $location.search();
      var value = search[param];
      if (typeof value !== "string") {
        return [];
      }

      return decodeURIComponent(value).split(",").map(function (c) {
        return c.trim();
      }).filter(function (c) {
        return c !== "";
      }).unique();
    }

    // TODO: put into common file
    function _isValidDate(str) {
      var date = new Date(str);

      if (Object.prototype.toString.call(date) !== "[object Date]") return false;

      if (isNaN(date.getTime())) return false;

      return true;
    }

    // TODO: put into common file
    function _isNumber(n) {
      return !isNaN(parseFloat(n)) && isFinite(n);
    }
  }
})(window.angular);


// WEBPACK FOOTER //
// ./app/compliance/compliance-querystring.component.js